export const shippingMessagesApi = (http) => {
  return {
    fetchShippingMessages: async () => {
      return http.get(`/api/provider_shipping_messages/`);
    },
  };
};
